import './Footer.css'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import ScheduleIcon from '@mui/icons-material/Schedule'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import SmartphoneIcon from '@mui/icons-material/Smartphone'
import BadgeIcon from '@mui/icons-material/Badge'

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h2 className="footer-title">Vélvirki ehf</h2>
          <p>
            Vélvirki ehf. sérhæfir sig í stálsmíði og viðgerðum með áratuga reynslu og 
            áreiðanlegum lausnum.
          </p>
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FacebookIcon />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h3>Flýtileiðir</h3>
          <nav className="footer-links">
            <a href="/">Heim</a>
            <a href="/thjonusta">Þjónusta</a>
            <a href="/um-okkur">Um Okkur</a>
            <a href="/hafa-samband">Hafa Samband</a>
          </nav>
        </div>

        <div className="footer-section">
          <h3>Hafðu Samband</h3>
          <div className="contact-info">
            <p><LocationOnIcon /> Hafnarbraut 7 620 Dalvík</p>
            <p><ScheduleIcon /> Virka daga 08:00 - 16:00</p>
            <p><EmailIcon /> velvirki@velvirki.is</p>
            <p><PhoneIcon /> +354 466-1088</p>
            <p><SmartphoneIcon /> Helgi 696-2145</p>
            <p><SmartphoneIcon /> Eiður Máni 893-2173</p>
            <p><BadgeIcon /> kt 620590 - 1699</p>
          </div>
        </div>

        <div className="footer-section">
          <div className="map">
            <iframe 
              src="https://www.openstreetmap.org/export/embed.html?bbox=-18.532276153564457%2C65.97115675115022%2C-18.52553844451904%2C65.97290471477857&amp;layer=mapnik&amp;marker=65.97203073974097%2C-18.528907299041748"
              style={{ 
                border: 0,
                width: '100%',
                height: '100%',
                borderRadius: '8px'
              }} 
              loading="lazy"
              title="Vélvirki ehf location"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer 